const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_pages/$lang/_about.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_pages/$lang/_about")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});